import { BrowserRouter } from "react-router-dom";
import Router from "./router/Router";
import { IconProvider } from "./design-system";
import { AuthProvider, APP_BASENAME } from "./auth";
import { ErrorBoundary } from "./components/layout/ErrorBoundary";
import "./services/telemetry.ts";

function App() {
  return (
    <IconProvider>
      <ErrorBoundary>
        <AuthProvider>
          <BrowserRouter basename={APP_BASENAME}>
            <Router />
          </BrowserRouter>
        </AuthProvider>
      </ErrorBoundary>
    </IconProvider>
  );
}

export default App;
